<template>
  <div class="team-profile-img text-center">
    <div
      class="avatar-container rounded-circle flex-shrink-0 overflow-hidden d-flex justify-content-center align-items-center"
      :style="{ width: size + 'px', height: size + 'px' }"
    >
      <!-- Si user.photo_url existe -->
      <img 
        :src="user?.photo_url || user?.person?.photo_url" 
        :alt="user?.username || 'Avatar'"
        class="member-img img-fluid d-block w-100 h-100 rounded-circle object-fit-cover" 
        v-if="user?.photo_url || user?.person?.photo_url" 
      />

      <!-- Sinon, on affiche les initiales -->
      <div
        class="avatar-placeholder text-white rounded-circle text-uppercase fw-bold d-flex justify-content-center align-items-center"
        :style="{
          width: size + 'px',
          height: size + 'px',
          backgroundColor: getColor(user),
          fontSize: fontSize + 'px'
        }"
        v-else
      >
        {{ getInitials(user) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  user: {
    type: Object,
    required: true
  },
  size: {
    type: Number,
    default: 40
  },
  fontSize: {
    type: Number,
    default: 14
  }
})

const getInitials = (user) => {
  if (!user) return ""
  const first = (user.person?.firstname || user.firstname || "").charAt(0).toUpperCase()
  const last = (user.person?.lastname || user.lastname || "").charAt(0).toUpperCase()
  return first + last
}

const getColor = (user) => {
  const colors = ["#0d6efd", "#198754", "#dc3545", "#ffc107", "#6f42c1", "#800000"]
  const key = (user.username || user.email || user.id || "default").toString()

  let hash = 0
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % colors.length
  return colors[index]
}
</script>

<style scoped>
.avatar-container {
  width: 100px;
  height: 100px;
}

.member-img {
  object-fit: cover;
}

.avatar-placeholder {
  width: 100px;
  height: 100px;
}

.team-cover {
  height: 120px;
  overflow: hidden;
}

.team-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>